import { Component, OnInit } from '@angular/core';
import screenfull from 'screenfull';

@Component({
    selector: 'app-toolbar-fullscreen-toggle',
    templateUrl: './toolbar-fullscreen-toggle.component.html',
    styleUrls: ['./toolbar-fullscreen-toggle.component.scss'],
    standalone: false
})
export class ToolbarFullscreenToggleComponent {

  isFullscreen: boolean = false;

  constructor() {
  }

  toggleFullscreen() {
    if (screenfull.isEnabled) {
      screenfull.toggle();
      this.isFullscreen = !this.isFullscreen;
    }
  }

}
